export function documentationBindings(flows) {
  const seen = new Set();
  return flows.filter(flow => {
    if (flow.source !== "tenant" || !flow.iid || !flow.flowId) return false;
    const key = JSON.stringify([flow.iid, flow.flowId]);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  }).map(flow => ({ instanceId: flow.iid, flowId: flow.flowId, packageId: flow.packageId || "",
    flowName: flow.zipInfo?.flowName || flow.flowId, main: !flow.auto }));
}

// Network chunks are not SSE frames. Preserve partial lines until the next read.
export async function readDocumentationStream(response, onText, onUsage) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let pending = "", full = "", complete = false;
  const consume = line => {
    if (!line.startsWith("data:")) return;
    const data = line.slice(5).trim();
    if (data === "[DONE]") { complete = true; return; }
    if (!data) return;
    const event = JSON.parse(data);
    if (event.error) throw new Error(event.error);
    if (event.text) { full += event.text; onText(full); }
    if (event.usage) onUsage(event.usage);
  };
  try {
    while (!complete) {
      const { done, value } = await reader.read();
      pending += done ? decoder.decode() : decoder.decode(value, { stream: true });
      const lines = pending.split(/\r?\n/);
      pending = lines.pop();
      for (const line of lines) { consume(line); if (complete) break; }
      if (done) { if (pending && !complete) consume(pending); break; }
    }
    if (!complete || !full.trim()) throw new Error("Documentation stream is incomplete");
    return full;
  } finally { await reader.cancel().catch(() => {}); reader.releaseLock(); }
}
